// types
import { PaletteThemeProps } from 'types/theme';
import { PalettesProps } from '@ant-design/colors';
import { ThemeMode } from 'types/config';
import { generateColorVariants } from '../../utils/theme-helper';

// ==============================|| PRESET THEME - THEME 9 ||============================== //

const Default = (colors: PalettesProps, mode: ThemeMode): PaletteThemeProps => {
  // const { grey } = colors;

  const isDark = mode === 'dark';
  const primaryVariants = generateColorVariants('#00897B');
  const secondaryVariants = generateColorVariants('#F7F8FA');
  const errorVariants = generateColorVariants('#d13c31');
  const warningVariants = generateColorVariants('#E67E22');
  const infoVariants = generateColorVariants('#058e98');
  const successVariants = generateColorVariants('#00897B');
  const greyVariants = generateColorVariants('#9CA3AF');
  const redVariants = generateColorVariants('#FF4040');
  const purpleVariants = generateColorVariants('#6C4CFF');
  const blueVariants = generateColorVariants('#2388FF');
  const slateGrayVariants = generateColorVariants('#6F7798');
  const yellowVariants = generateColorVariants('#F59E0C');

  const backgroundVariants = {
    default: isDark ? '#0B0F20' : '#F7F8FA',
    paper: isDark ? '#0D0F12' : '#FFFFFF'
  };
  const textVariants = {
    primary: isDark ? '#F7F8FA' : '#0B0F20',
    secondary: isDark ? greyVariants.default[200] : '#6B7580',
    disabled: isDark ? greyVariants.default[500] : '#9EA4AD'
  };
  const action = {
    disabled: greyVariants.default[300]
  };
  const divider = isDark ? '#333333' : '#EDEEF0';
  const border = {
    main: isDark ? '#333333' : '#EDEEF0'
  };
  const navGroup = {
    main: '#B1B6BD'
  };

  return {
    primary: isDark ? primaryVariants.dark : primaryVariants.default,
    error: isDark ? errorVariants.dark : errorVariants.default,
    warning: isDark ? warningVariants.dark : warningVariants.default,
    info: isDark ? infoVariants.dark : infoVariants.default,
    success: isDark ? successVariants.dark : successVariants.default,
    secondary: isDark ? secondaryVariants.dark : secondaryVariants.default,
    grey: greyVariants.default,
    red: redVariants.default,
    purple: purpleVariants.default,
    blue: blueVariants.default,
    slateGray: slateGrayVariants.default,
    text: textVariants,
    background: backgroundVariants,
    yellow: yellowVariants.default,
    action,
    divider,
    border,
    navGroup
  };
};

export default Default;
